import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { rydeColors, rydeColorsDashboardPage } from "@ryde/theme";

export const DashboardPageStyled = styled.div`
  display: grid;
  justify-items: center;
  align-items: center;
  grid-template-areas:
    "pad01 pad02 pad03"
    "pad11 header pad13"
    "pad21 pad22 pad23"
    "pad31 cards pad33"
    "pad41 pad42 pad43";
  grid-template-columns: auto 100% auto;
  grid-template-rows: auto 15% 10% 70% auto;
`;
export const DashboardHeaderBarStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "dashboard-header-bar",
})`
  grid-area: header;
  display: grid;
  align-items: center;
  padding-inline-end: 15px;
  width: 90%;
  gap: 10px;
  height: 62px;
  background: ${rydeColors.white};
  border: 1px solid ${rydeColorsDashboardPage.dashboardHeaderBorderColor};
  border-radius: 5px;
  grid-template-areas: "bell alerts padgap date";
  grid-template-columns: 2% 40% auto 20%;
  @media (max-width: 1500px) {
    grid-template-columns: 2% 60% auto 20%;
  }
  @media (max-width: 1200px) {
    grid-template-columns: 4% 50% auto 20%;
  }
`;
export const BellContainer = styled.div`
  margin-inline-start: 10px;
  grid-area: bell;
  align-items: end;
`;
export const Separator = styled.span`
  display: flex;
  align-items: center;
  color: ${rydeColors.black};
  font-size: 24px;
  margin: 10px;
`;

export const AlertsContainer = styled.div`
  grid-area: alerts;
  display: flex;
  align-items: center;
`;

export const AlertText = styled.span<{ $colorCalc: string }>`
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-transform: uppercase;
  color: ${rydeColorsDashboardPage.alertText};
  display: flex;
  align-items: center;
  ${({ $colorCalc }) => {
    return { color: $colorCalc };
  }};
`;
export const AlertSecondaryText = styled.span`
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-transform: uppercase;
  color: ${rydeColorsDashboardPage.alertSecondaryText};
  padding-inline-start: 2px;
  align-items: center;
  margin: 0 10px 0 5px;
`;
export const DateText = styled.span`
  grid-area: date;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-transform: uppercase;
  color: ${rydeColorsDashboardPage.dateTextColor};
  margin-inline-start: auto;
`;
export const CardContainerStyled = styled.div`
  grid-area: cards;
  display: grid;
  grid-template-columns: repeat(3, minmax(33%, 1fr));
  grid-template-rows: repeat(auto-fit, minmax(280px, 1fr));
  grid-gap: 5px;
  justify-content: space-between;
  width: 90%;
  height: auto;
  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, minmax(49%, 1fr));
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const DashboardCardStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "dashboard-card",
})`
  border: 1px solid ${rydeColorsDashboardPage.dashboardCardBorder};
  background-color: ${rydeColors.white};
  border-radius: 4px;
  padding: 16px;
  width: 100%;
  height: 280px;
`;

export const DashboardCardHeader = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "dashboard-card-header",
})`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  color: ${rydeColorsDashboardPage.cardHeaderColor};
  border-bottom: 0.5px solid ${rydeColorsDashboardPage.dashboardCardBorder};
  height: 15%;
`;

export const DashboardCardHeaderTitle = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  display: flex;
  align-items: center;
  color: ${rydeColors.black};
  top: 0;
  inset-inline-start: 0;
`;
